import { Suspense } from "react";
import { useRouteContext } from "@tanstack/react-router";
import UploadInstructions from "@/components/match-tool/UploadInstructions";
import UploadFilesCard from "@/components/match-tool/UploadFilesCard/UploadFilesCard";
import SubmittedFilesCard from "@/components/match-tool/SubmittedFilesCard/SubmittedFilesCard";
import Card from "@/components/shared/Card";

function SubmittedFilesCardSkeleton() {
  return (
    <Card className="mb-3">
      <div className="fs-5 fw-bold mb-3">Submitted Files</div>
      <div className="d-flex align-items-center gap-3 py-4">
        <div
          className="spinner-border spinner-border-sm"
          style={{ color: "#0d2d4a" }}
          role="status"
          aria-hidden="true"
        />
        <span style={{ color: "#0d2d4a" }}>Loading submitted files...</span>
      </div>
    </Card>
  );
}

export function CSPPIDMatchToolView() {
  const leaContext = useRouteContext({ from: "/$leaid" });

  if (!leaContext.hasFeature("CSPPID_Match")) {
    return <p className="text-muted mt-2">Content in development</p>;
  }

  return (
    <>
      <UploadInstructions />

      <UploadFilesCard className="mb-4" />

      <Suspense fallback={<SubmittedFilesCardSkeleton />}>
        <SubmittedFilesCard />
      </Suspense>
    </>
  );
}
